import AuthLayout from "../../components/layout/AuthLayout";
import RegisterBox from "../../components/registerBox/RegisterBox";
import { useEffect, useState } from "react";
import {
  AddressPage,
  HasRegisteredPage,
  PersonalInformationPage,
} from "../../router/path-route/PathRoute";
import { useNavigate } from "react-router-dom";
import { RequestOTP, checkOTP } from "../../auth/Index";
import DownloadAppDrawer from "../../components/drawer/DownloadAppDrawer";

const OTP_SECONDS = 300;

const formatTime = (total) => {
  const minutes = String(Math.floor(total / 60)).padStart(2, "0");
  const seconds = String(total % 60).padStart(2, "0");
  return { minutes, seconds };
};

export default function OTP() {
  const [inputValue, setInputValue] = useState("");
  const [remaining, setRemaining] = useState(OTP_SECONDS);
  const [errorMessage, setErrorMessage] = useState("");
  const [err, setErr] = useState(true);
  const [showDrawer, setShowDrawer] = useState(false);
  const navigate = useNavigate();

  useEffect(() => {
    const timer = setInterval(() => {
      setRemaining((prev) => (prev <= 1 ? 0 : prev - 1));
    }, 1000);
    return () => clearInterval(timer);
  }, []);

  useEffect(() => {
    if (inputValue.length === 6) {
      const mobile = localStorage.getItem("mobile") || "";
      const data = {
        mobile,
        identityCode: localStorage.getItem("identityCode"),
        otp: inputValue,
        isLogin: mobile === "",
        role: 5,
        nationality: "IR",
      };
      checkOTP(data)
        .then((res) => {
          if (res.status === 200) {
            localStorage.setItem("userID", res.data.userId);
            localStorage.setItem("token", res.data.token);
            localStorage.setItem("hasRegistered", res.data.hasRegistered);
            localStorage.setItem("isCompleted", res.data.isCompleted);
            if (res.data.registrationStatus === "NotRegistered") {
              navigate(PersonalInformationPage);
            } else if (res.data.registrationStatus === "NoProfile") {
              navigate(AddressPage);
            } else if (res.data.registrationStatus === "NotCompleted") {
              setShowDrawer(true);
            } else if (res.data.registrationStatus === "Completed") {
              navigate(HasRegisteredPage);
            }
          }
        })
        .catch((err) => {
          setErrorMessage(err.response?.data?.message || "");
          setErr(false);
        });
    }
  }, [inputValue, navigate]);

  useEffect(() => {
    if (inputValue === "" || inputValue.length === 0) {
      setErr(true);
    }
  }, [inputValue]);

  const handleResend = () => {
    if (remaining > 0) return;
    const mobile = localStorage.getItem("mobile") || "";
    const data = {
      mobile,
      identityCode: localStorage.getItem("identityCode"),
      isLogin: mobile === "",
      nationality: "IR",
    };
    RequestOTP(data)
      .then((res) => {
        if (res.status === 200) {
          setRemaining(OTP_SECONDS);
          setErr(true);
          setErrorMessage("");
          setInputValue("");
        }
      })
      .catch((err) => {
        if (err.response?.status === 405) {
          setRemaining(OTP_SECONDS);
          setErr(true);
          setInputValue("");
        } else {
          setErrorMessage(err.response?.data?.message || "");
          setErr(false);
        }
      });
  };

  const { minutes, seconds } = formatTime(remaining);

  return (
    <AuthLayout previousPage={-1}>
      <RegisterBox
        bgButton={remaining === 0}
        setInputValue={setInputValue}
        inputValue={inputValue.slice(0, 6)}
        placeholder="------"
        btnTitle="ارسال مجدد کد"
        title="کد یکبار مصرف ارسال شده را وارد نمایید."
        otp={true}
        minutes={minutes}
        seconds={seconds}
        errorMessage={errorMessage}
        err={err}
        handleClick={handleResend}
      />
      <DownloadAppDrawer open={showDrawer} />
    </AuthLayout>
  );
}
